export var sizes = {
  medium: {
    fontSize: 2,
    minimizedTranslateX: '0px',
    minimizedTranslateY: '6px',
    translateX: '0px',
    translateY: '14px'
  }
};
export var _getInputLabelStyles = function _getInputLabelStyles(_ref) {
  var size = _ref.size,
      isInputFilled = _ref.isInputFilled,
      isInputFocused = _ref.isInputFocused,
      disabled = _ref.disabled;
  var shouldMinimizeLabel = isInputFilled || isInputFocused;
  var mx = sizes[size].minimizedTranslateX;
  var my = sizes[size].minimizedTranslateY;
  var x = sizes[size].translateX;
  var y = sizes[size].translateY;
  return {
    zIndex: shouldMinimizeLabel ? 'minimum' : null,
    position: 'absolute',
    transformOrigin: 'top left',
    transform: shouldMinimizeLabel ? "translate(".concat(mx, ", ").concat(my, ") scale(0.75)") : "translate(".concat(x, ", ").concat(y, ") scale(1)"),
    transition: "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
    color: disabled ? 'grey.400' : isInputFocused ? 'blue.500' : 'grey.600',
    fontSize: sizes[size].fontSize
  };
};